import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import ESGselcard from "./ESGselcard";
import data from "./ESGsel.json";

function ESGselect() {
  const [isSelected1, setIsSelected1] = useState(true);
  const [isSelected2, setIsSelected2] = useState(true);
  const [isSelected3, setIsSelected3] = useState(true);
  const [isSelected4, setIsSelected4] = useState(true);
  const [isSelected5, setIsSelected5] = useState(true);
  const [isResult, setIsResult] = useState(false);
  const [inputValues, setInputValues] = useState({});
  const [highlightedCards, setHighlightedCards] = useState([]);
  const [filteredData, setFilteredData] = useState(data);

  const questionsForCategory5 = filteredData.filter(
    (item) => item.categoryId == 5
  );

  useEffect(() => {
    // LocalStorage에서 ESGtype 가져오기
    const ESGtype = parseInt(localStorage.getItem("ESGtype"), 10);

    if (ESGtype >= 40) {
      // type_b가 true인 데이터만 필터링
      setFilteredData(data.filter((item) => item.type_b));
    } else {
      // 모든 데이터 유지
      setFilteredData(data);
    }
  }, []);

  const handleInputChange = (pk, value) => {
    setInputValues((prev) => ({ ...prev, [pk]: value }));
  };

  const handleSubmit = () => {
    const incompleteFields = [];
    const results = [];

    // Validate choices and inputs across all categories
    filteredData.forEach((question) => {
      if (!inputValues[question.pk]) {
        incompleteFields.push(question.pk); // 누락된 필드의 pk 추가
      } else {
        if (question.choices) {
          const choiceIndex = question.choices.indexOf(
            inputValues[question.pk]
          );
          const score = 3 - choiceIndex;
          results.push({ pk: question.pk, score });
        } else {
          results.push({ pk: question.pk, value: inputValues[question.pk] });
        }
      }
    });

    // Highlight incomplete fields
    setHighlightedCards(incompleteFields);

    if (incompleteFields.length > 0) {
      return; // Stop submission if there are incomplete fields
    }

    // Convert results to JSON string and Base64 encode it
    const resultsString = JSON.stringify(results); // 결과를 JSON 문자열로 변환
    const encryptedResults = btoa(resultsString); // Base64로 암호화

    // Update URL with encoded query string
    const newUrl = `${window.location.origin}${window.location.pathname}/result?data=${encryptedResults}`;
    window.location.href = newUrl;

    setIsResult(true); // Set result display flag
  };

  return (
    <Container>
      <Row>
        <Col md="12" className="faq-section" style={{ textAlign: "left" }}>
          <div key="1" style={{ marginBottom: "15px" }}>
            <h2
              style={{
                fontSize: "1.5em",
                cursor: "pointer",
                userSelect: "none",
              }}
              onClick={() => setIsSelected1(!isSelected1)}
            >
              {isSelected1 ? "▼" : "▶"} {"환경 경영 체계"}
            </h2>
            {isSelected1 && (
              <div style={{ marginLeft: "20px" }}>
                <ESGselcard
                  categoryId={1}
                  highlightedCards={highlightedCards} // 전달
                  inputValues={inputValues} // 상태 전달
                  handleInputChange={handleInputChange} // 상태 변경 함수 전달
                />
              </div>
            )}
          </div>
          <div key="2" style={{ marginBottom: "15px" }}>
            <h2
              style={{
                fontSize: "1.5em",
                cursor: "pointer",
                userSelect: "none",
              }}
              onClick={() => setIsSelected2(!isSelected2)}
            >
              {isSelected2 ? "▼" : "▶"} {"환경 성과"}
            </h2>
            {isSelected2 && (
              <div style={{ marginLeft: "20px" }}>
                <ESGselcard
                  categoryId={2}
                  highlightedCards={highlightedCards} // 전달
                  inputValues={inputValues} // 상태 전달
                  handleInputChange={handleInputChange} // 상태 변경 함수 전달
                />
              </div>
            )}
          </div>
          <div key="3" style={{ marginBottom: "15px" }}>
            <h2
              style={{
                fontSize: "1.5em",
                cursor: "pointer",
                userSelect: "none",
              }}
              onClick={() => setIsSelected3(!isSelected3)}
            >
              {isSelected3 ? "▼" : "▶"} {"공급망"}
            </h2>
            {isSelected3 && (
              <div style={{ marginLeft: "20px" }}>
                <ESGselcard
                  categoryId={3}
                  highlightedCards={highlightedCards} // 전달
                  inputValues={inputValues} // 상태 전달
                  handleInputChange={handleInputChange} // 상태 변경 함수 전달
                />
              </div>
            )}
          </div>
          <div key="4" style={{ marginBottom: "15px" }}>
            <h2
              style={{
                fontSize: "1.5em",
                cursor: "pointer",
                userSelect: "none",
              }}
              onClick={() => setIsSelected4(!isSelected4)}
            >
              {isSelected4 ? "▼" : "▶"} {"친환경 서비스"}
            </h2>
            {isSelected4 && (
              <div style={{ marginLeft: "20px" }}>
                <ESGselcard
                  categoryId={4}
                  highlightedCards={highlightedCards} // 전달
                  inputValues={inputValues} // 상태 전달
                  handleInputChange={handleInputChange} // 상태 변경 함수 전달
                />
              </div>
            )}
          </div>
          <div key="5" style={{ marginBottom: "15px" }}>
            <h2
              style={{
                fontSize: "1.5em",
                cursor: "pointer",
                userSelect: "none",
              }}
              onClick={() => setIsSelected5(!isSelected5)}
            >
              {isSelected5 ? "▼" : "▶"} {"정량 데이터 입력"}
            </h2>
            {isSelected5 && (
              <div style={{ marginLeft: "20px" }}>
                {questionsForCategory5.map((question) => (
                  <Card
                    key={question.pk}
                    style={{
                      marginBottom: "15px",
                      border: highlightedCards.includes(question.pk)
                        ? "2px solid red"
                        : "1px solid #ccc", // 하이라이트 처리
                    }}
                  >
                    <Card.Body>
                      <h5>{question.problem}</h5>
                      <Form.Control
                        type="text"
                        value={inputValues[question.pk] || ""}
                        onChange={(e) => {
                          const value = e.target.value;
                          // 숫자만 허용
                          if (/^\d*$/.test(value)) {
                            handleInputChange(question.pk, value);
                          }
                        }}
                      />
                    </Card.Body>
                  </Card>
                ))}
              </div>
            )}
          </div>
          <Row>
            <Col style={{ textAlign: "center", marginTop: "20px" }}>
              <Button
                onClick={handleSubmit}
                variant="primary"
                style={{ width: "100%" }}
              >
                제출
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export default ESGselect;
